var _style, _polygon, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCpcsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 350 400",
    style: {
      enableBackground: "new 0 0 350 400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#EA3B2F;}\n\t.st2{fill:#171B4B;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "66.7,844.8 -16.5,797.3 -16.5,892.3 66.7,844.8 "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "350,200 350,200 0,0 0,152.3 83.6,200  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "83.6,200 83.6,200 0,247.7 0,400 350,200  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpcsLogo);
export default __webpack_public_path__ + "static/media/cpcs_logo.3669fa73d6abb16ca0ed692304f82b8e.svg";
export { ForwardRef as ReactComponent };